export const EuroFormatter = new Intl.NumberFormat(`it-IT`, {
  currency: `EUR`,
  style: "currency",
});
